import { Link } from "react-router-dom";
import { ArrowRight, HelpCircle } from "lucide-react";
import SEO from "@/components/SEO";

const FAQS = [
  {
    q: "How long does a Booty Breeze freshener last?",
    a: "Every Booty Breeze is hand-poured and cured for slow release. In a daily-driver setup (60–90 minutes on the road per day, windows up), expect 3–4 weeks of noticeable scent — roughly 3–4× the lifespan of a typical cardboard gas-station tree freshener. Cured pieces last longer if you rotate them or keep them out of direct sunlight when parked.",
  },
  {
    q: "Is this really adults-only?",
    a: "Yes. The branding is designed for grown drivers — nothing explicit, but it's not made for kids either. That's why the site has an age gate at the front door. It's built to be a bold, funny, adult accessory or gift — the kind that gets a laugh from your passenger before it earns a compliment on the scent.",
  },
  {
    q: "How much is shipping? Is it discreet?",
    a: "Free shipping on U.S. orders over $10 (that's any two fresheners). Under that, standard tracked shipping applies. Every package ships in plain outer packaging — the branding is inside the box, not on it. Orders usually leave the warehouse within 1–2 business days.",
  },
  {
    q: "Do you ship internationally?",
    a: "Right now we ship to the U.S., Canada, U.K., and Australia. If your country isn't in the checkout list yet, drop a note to admin@bootybreeze.com and we'll add it if there's demand.",
  },
  {
    q: "What if I don't love the scent?",
    a: "Fragrance is personal. If a scent doesn't hit for you, email admin@bootybreeze.com within 30 days of delivery and we'll either swap it or refund the freshener — no long questionnaire, no return-shipping games.",
  },
  {
    q: "How is Booty Breeze different from a cheap tree freshener?",
    a: "Cheap tree fresheners are printed cardboard soaked in a mass-market fragrance oil — they smell strong for 3–5 days then die. Booty Breeze uses hand-poured fragrance-oil discs on a laminated body, cured in small batches. The result is bolder top notes, a heavier base, and a real 3–4 week runway. Plus the branding is grown-up — you won't be embarrassed when your passenger looks up.",
  },
  {
    q: "Can I gift a Booty Breeze?",
    a: "Yes — this is one of the most-gifted funny car accessories we ship. Common gift use cases: white elephant, stocking stuffers, gag gifts for guys who already have everything, and bachelor/bachelorette add-ons. Under $10, ships discreetly, and lasts a month.",
  },
  {
    q: "How do I hang it?",
    a: "Straight from the rearview mirror by the loop that ships attached. Peel the protective film off both faces on day one to activate the scent. Don't lay flat on a dashboard in direct summer sun — it'll cure faster and shorten the runway.",
  },
];

export default function FAQ() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": FAQS.map(({ q, a }) => ({
      "@type": "Question",
      "name": q,
      "acceptedAnswer": { "@type": "Answer", "text": a },
    })),
  };
  return (
    <div className="min-h-screen" data-testid="faq-page">
      <SEO
        title="FAQ — Booty Breeze Adult Car Air Fresheners"
        description="How long do our fresheners last? Do we ship discreetly? What if you don't love the scent? Straight answers to the questions people actually ask before buying."
        path="/faq"
        jsonLd={jsonLd}
      />

      <section className="max-w-3xl mx-auto px-6 sm:px-10 pt-20 pb-8 text-center">
        <HelpCircle className="mx-auto text-[#A855F7]" size={22} />
        <h1 className="font-display text-5xl sm:text-6xl leading-tight text-white mt-4">
          Straight answers, <br />
          <span className="text-neon-pink">no fine print.</span>
        </h1>
        <p className="text-white/70 mt-6 max-w-xl mx-auto leading-relaxed">
          Everything people actually ask before their first Booty Breeze. If your
          question isn't here, email us at{" "}
          <a href="mailto:admin@bootybreeze.com" className="text-[#FF3D8B] hover:underline">
            admin@bootybreeze.com
          </a>.
        </p>
      </section>

      <section className="max-w-3xl mx-auto px-6 sm:px-10 py-10">
        <div className="space-y-4">
          {FAQS.map(({ q, a }, i) => (
            <details
              key={q}
              data-testid={`faq-item-${i}`}
              className="group rounded-2xl border border-white/10 bg-white/[0.02] hover:border-[#FF3D8B]/30 transition-colors"
            >
              <summary className="cursor-pointer list-none px-6 py-5 flex justify-between items-start gap-4">
                <span className="font-display text-lg text-white leading-tight">
                  {q}
                </span>
                <span className="text-[#FF3D8B] text-2xl leading-none group-open:rotate-45 transition-transform">
                  +
                </span>
              </summary>
              <p className="px-6 pb-6 text-white/70 leading-relaxed">{a}</p>
            </details>
          ))}
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 sm:px-10 py-16 text-center border-t border-white/10">
        <h2 className="font-display text-3xl text-white">Ready to pick your mood?</h2>
        <Link
          to="/shop"
          data-testid="faq-shop-cta"
          className="pulse-pink mt-6 inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#FF3D8B] text-black font-bold uppercase tracking-wider text-sm hover:bg-[#ff5ba0] transition-colors"
        >
          Shop the collection <ArrowRight size={18} />
        </Link>
      </section>
    </div>
  );
}
